import { makeStyles, type Theme } from '@material-ui/core';
import backgroundImg from 'src/assets/images/background.jpg';

export default makeStyles((theme: Theme) => ({
	container: {
		height: '100vh',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		backgroundImage: `url(${backgroundImg})`,
		backgroundSize: 'cover',
	},
	card: {
		width: 400,
		opacity: 0.95,
		'& h3': {
			textAlign: 'center',
		},
	},
	actions: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		padding: theme.spacing(1, 2),
		'& a': {
			color: theme.palette.secondary.main,
			fontSize: 14,
			fontWeight: 500,
		},
	},
	button: {
		height: 36,
		width: 140,
		maxWidth: 140,
	},
}));
